module.exports = __webpack_public_path__ + "static/media/bed-empty.546ea96b.svg";